import { arrowLeft } from 'assets';
import { Button, Modal } from 'components';
import { FC, useCallback, useEffect, useState } from 'react';
import { GetDetailImageResponse, ImageAlbum } from 'types';

import { Skeleton } from 'antd';
import { dayjs } from 'libs';
import GraftImageModal from './GraftImage';
import { HeaderStyled, DetailImageContentStyled } from './styles';
import { CutImageModal } from './index';

interface Props {
  data?: ImageAlbum | null;
  onClickCompose: () => void;
  onClickCut: () => void;
  visible: boolean;
  showModal: (open: boolean) => void;
  images: ImageAlbum[];
  detailImage: GetDetailImageResponse | null;
  setLoadingOneImage: any;
  loadingOneImage: any;
  dataWorker: any;
}

const DetailImage: FC<Props> = ({
  visible,
  detailImage,
  loadingOneImage,
  setLoadingOneImage,
  images,
  data,
  showModal,
  dataWorker,
}) => {
  const [visibleModalImage, setVisibleModalImage] = useState(false);
  const [visibleModalGraftImage, setVisibleModalGraftImage] = useState(false);
  const [convertImage, setConvertImage] = useState<string>('');

  const handleClickCutImage = useCallback(async () => {
    showModal(false);
    setVisibleModalImage(true);
  }, [showModal]);

  const handleClickGraftImage = useCallback(async () => {
    setVisibleModalGraftImage(true);
    showModal(false);
  }, [showModal]);

  const getBase64FromUrl = async (url: '' | undefined | string) => {
    try {
      if (url) {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          };
        });
      }
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    const f = async () => {
      const convertItemImage =
        detailImage?.image_url &&
        detailImage?.image_url.replace(
          process.env.REACT_APP_S3_RES_URL || '',
          process.env.REACT_APP_RES_URL || ''
        );
      const imgBase: any = await getBase64FromUrl(convertItemImage);
      imgBase && setConvertImage(imgBase);
    };
    f();
  }, [detailImage]);

  const onCancelModal = () => {
    showModal(false);
    setLoadingOneImage(true);
  };
  return (
    <>
      <Modal
        title={
          <HeaderStyled onClick={onCancelModal}>
            <img src={arrowLeft} alt="arrowLeft" />
            <div>写真詳細</div>
          </HeaderStyled>
        }
        visible={visible}
        footer={false}
        width={960}
      >
        <DetailImageContentStyled>
          <div className="image">
            {loadingOneImage ? (
              <Skeleton.Button active style={{ width: 600, height: 450, maxWidth: '100%' }} />
            ) : (
              <img src={detailImage?.image_url} alt="img-modal" className="image image-graft" />
            )}
          </div>
          <div className="info">
            <div className="title">情報</div>
            <div className="info-item">工事コード：{detailImage?.building_code}</div>
            <div className="info-item">現場名：{detailImage?.site_name}</div>
            {/** 2024/01/30 Leading Win 写真機能対応 DXWEBTPG00101_写真詳細 start*/}
            {/** <div className="info-item">種別：{detailImage?.daikoji_name || 'その他'}</div>*/}
            {/** 2024/01/30 Leading Win 写真機能対応 DXWEBTPG00101_写真詳細 end*/}
            <div className="info-item">撮影者：{detailImage?.taken_user_name}</div>
            <div className="info-item">
              撮影日時：
              {detailImage?.taken_date
                ? dayjs(detailImage?.taken_date).format('YYYY/MM/DD HH:mm')
                : ''}
            </div>
            <div className="info-item">コメント：{detailImage?.comment}</div>
          </div>
        </DetailImageContentStyled>
        <div className="ant-modal-footer">
          <Button onClick={handleClickCutImage}>切り抜き</Button>
          <Button onClick={handleClickGraftImage}>写真合成</Button>
        </div>
      </Modal>
      <CutImageModal
        detailImage={detailImage}
        visible={visibleModalImage}
        onCancel={() => {
          setVisibleModalImage(false);
        }}
        data={data}
        showModal={showModal}
        closeModalImage={setVisibleModalImage}
        convertImage={convertImage}
      />
      {visibleModalGraftImage && (
        <GraftImageModal
          detailImage={detailImage}
          visible={visibleModalGraftImage}
          onCancel={() => {
            setVisibleModalGraftImage(false);
          }}
          data={data}
          images={images}
          showModal={showModal}
          closeModalImage={setVisibleModalGraftImage}
          convertImage={convertImage}
          dataWorker={dataWorker}
        />
      )}
    </>
  );
};

export default DetailImage;
